import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import FAQ from '../components/FAQ'
import HowItWorks from '../components/HowItWorks'
import SpinWheel from '../components/SpinWheel'
import Account from '../components/Account'
import DeliveryDetails from '../components/DeliveryDetails'
import DeliveryDetailsConfirmation from '../components/DeliveryDetailsConfirmation'
import PhysicalPrize from '../components/PhysicalPrize'
import TelcoPrize from '../components/TelcoPrize'
import SocialConfirmation from "../components/SocialConfirmation"
import SocialShare from "../components/SocialShare"
import Winners from "../components/Winners"

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    alias: '/i=:key',
    name: 'Home',
    component: Home
  },
  {
    path: '/faq',
    name: 'Faq',
    component: FAQ
  },
  {
    path: '/howItWorks',
    name: 'HowItWorks',
    component: HowItWorks
  },
  {
    path: '/gameOptions',
    redirect: '/'
  },
  {
    path: '/wheel',
    name: 'SpinWheel',
    component: SpinWheel
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/prize',
    name: 'PhysicalPrize',
    component: PhysicalPrize
  },
  {
    path: '/deliveryDetails',
    name: 'DeliveryDetails',
    component: DeliveryDetails
  },
  {
    path: '/confirmDelivery',
    name: 'DeliveryDetailsConfirmation',
    component: DeliveryDetailsConfirmation
  },
  {
    path: '/telco',
    name: 'TelcoPrize',
    component: TelcoPrize
  },
  {
    path: '/share',
    name: 'SocialShare',
    component: SocialShare
  },
  {
    path: '/socialConfirmation',
    name: 'SocialConfirmation',
    component: SocialConfirmation
  },
  {
    path: '/winners',
    name: 'Winners',
    component: Winners
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      const options = {
        top: document.querySelector(to.hash).offsetTop-110,
        behavior: 'smooth'
      }
      window.scrollTo(options)
    }
  }
})

router.beforeEach((to, from, next) => {
  next()
})

router.afterEach((to, from, next) => {
  let dataLayer = window.dataLayer
  if (dataLayer !== undefined) {
    dataLayer.push({
      'event': 'virtualPageview',
      'pagePath': window.location.href,
      'pageTitle': to.name
    });
    console.log('datalayer page view: ' + window.location.href + " " + to.name)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js